export function appendPath() {
    throw new Error('This method is not available in the browser');
}
//# sourceMappingURL=appendPath.browser.js.map